module.exports = __webpack_public_path__ + "img/title-min.cdfad548.png";